import { ApiV1_Product } from '@pedix-workspace/api-v1';

export type ProductDetailsType = 'simple' | 'with-presentations';

export const getProductDetailsType = (
  product: Pick<ApiV1_Product, 'presentations'>,
): ProductDetailsType =>
  (product.presentations?.items?.length ?? 0) > 0 ? 'with-presentations' : 'simple';
